const FORM_TABLE_EVENT = {
    TRIGGER_CLICK: "triggerClick",
}

const FORM_TABLE_EVENT_DISPATCHER = {
    /**
     * target 에 td 강제 클릭 이벤트를 발생시킵니다.
     */
    TRIGGER_CLICK: (target) => {
        target.dispatchEvent(new Event("triggerClick"));
    },
}

export {FORM_TABLE_EVENT_DISPATCHER}